// import { Map } from 'immutable'
import { Accepted, getCookie, Cookies, cookies, Cookie } from '../../utils/cookies'
import { getCurrentCookies } from '../../utils/datalayer.mapping'

export type CookiebarState = {
  cookies: Map<Cookie, Accepted>
  expandOptions: boolean
  visible: boolean
}

export const initialCookiebarState = (): CookiebarState => {
  const currentCookies = getCurrentCookies()
  return {
    cookies: currentCookies,
    expandOptions: false,
    visible: getCookie('showCookies') !== 'no',
  }
}

export const cookiebarStateUpdaters = {
  visibleUpdater:
    (visible: boolean) =>
    (currentState: CookiebarState): CookiebarState => ({
      ...currentState,
      visible: visible,
    }),
  expandOptionsUpdater: (currentState: CookiebarState): CookiebarState => ({
    ...currentState,
    expandOptions: !currentState.expandOptions,
  }),
  selectedCookiesUpdater:
    (cookies: Cookies, applyCookies: boolean) =>
    (currentState: CookiebarState): CookiebarState => ({
      ...currentState,
      cookies: applyCookies ? cookies : currentState.cookies,
    }),
  applyCookiesUpdater: (currentState: CookiebarState): CookiebarState => ({
    ...currentState,
    cookies: currentState.cookies,
    visible: false,
  }),
  allCookiesUpdater:
    (isAccepted: Accepted) =>
    (currentState: CookiebarState): CookiebarState => {
      const updatedCookies = cookies.reduce((prev, curr) => prev.set(curr, isAccepted), currentState.cookies)
      return {
        ...currentState,
        cookies: updatedCookies,
        visible: false,
      }
    },
}
